import React, {useState} from "react";
import TextValidator from "./TextValidator";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FileUpload from "./FileUpload";
import {apiURL} from "../api";
import TextField from "@material-ui/core/es/TextField/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

function GenerateInput(props) {
    let [value, setValue] = useState(props.defaultValue || "");
    let [error, setError] = useState("");
    let [disabled, setDisabled] = useState(false);
    let [customStyles, setCustomStyles] = useState({});

    let {...other} = props;
    if (other.fullWidth === undefined) {
        other.fullWidth = true;
    }
    let field = null;
    if (props.type === "select") {
        field = <div><FormControl disabled={disabled} style={{minWidth: 200}}>
            {props.label ? <InputLabel>{props.label}</InputLabel> : null}
            <Select
                value={value}
                onChange={(ev) => setValue(ev.target.value)}
            >
                {!props.required ? <MenuItem value="">
                    <em>None</em>
                </MenuItem> : null}
                {props.selection.map((item, index) => <MenuItem value={item.key}>{item.label}</MenuItem>)}
            </Select>
            {error !== "" || props.help ? <FormHelperText>{error === "" ? props.help : error}</FormHelperText> : null}
        </FormControl><br/></div>;
    } else if (props.type === "file") {
        field = <div>
            <FormControl>
                {props.label ? <InputLabel>{props.label}</InputLabel> : null}
                <div>
                    <FileUpload disabled={disabled} onFiles={(files) => setValue(props.multi ? files : files[0])}/>
                </div>
                <div>
                    {value && typeof value === "string" ?
                        <img src={apiURL('serve/' + value + "?width=100")} style={{maxWidth: 200, height: 'auto'}}
                             alt={""}/> : null}
                </div>
                {error !== "" || props.help ?
                    <FormHelperText>{error === "" ? props.help : error}</FormHelperText> : null}
            </FormControl>
        </div>
    } else if (props.type === "hidden") {
        field = <input disabled={disabled} type={"hidden"} value={value}
                       onChange={(event) => setValue(event.target.value)}/>
    } else if (props.type === "plain_textarea") {
        field = <textarea value={value} className={"plain-textarea"}
                          style={Object.assign({}, props.staticStyles || {}, customStyles)} disabled={disabled}
                          onChange={(event) => setValue(event.target.value)}>{value}</textarea>
    } else if (props.type === "checkbox") {

        field = <FormControlLabel
            control={
                <Checkbox
                    checked={value}
                    onChange={(event) => setValue(event.target.checked)}
                    value={true}
                />
            }
            label={props.label}
        />;
    } else if (props.type === "radio") {

        field = <FormControl component="fieldset">
            {props.label ? <FormLabel component="legend">{props.label}</FormLabel> : null}
            <RadioGroup value={value} onChange={(event) => setValue(event.target.value)}>
                {props.selection.map((item, index) => <FormControlLabel key={item.key} value={item.key}
                                                                        control={<Radio/>} label={item.label}/>)}
            </RadioGroup>
        </FormControl>;
    } else {

        let textarea = props.type === "textarea";
        field = <TextValidator
            value={value}
            multiline={textarea}
            disabled={disabled}
            rows={5}
            inputProps={
                {
                    style: Object.assign({height: textarea ? 'auto' : undefined}, props.staticStyles || {}, customStyles)
                }
            }
            error={error === "" ? null : true}
            helperText={error === "" ? props.help : error}
            onChange={(event) => setValue(event.target.value)}
            margin="normal"
            variant="outlined"
            {...other}
        />;
    }

    return {
        value,
        error,
        setError,
        setDisabled,
        disabled,
        setValue,
        field,
        setCustomStyles
    };
}

function GenerateInputs(specs) {
    let out = {};
    for (let spec of Object.keys(specs)) {
        out[spec] = GenerateInput(specs[spec]);
        out[spec].name = spec;
    }
    out.toData = () => {
        let nout = {};
        for (let spec of Object.keys(specs)) {
            nout[spec] = out[spec].value;
        }
        return nout;
    };

    out.toFormData = () => {
        const formData = new FormData();
        for (let spec of Object.keys(specs)) {
            formData.append(spec, out[spec].value);
        }
        return formData;
    };

    out.disableAll = (state) => {
        for (let spec of Object.keys(specs)) {
            out[spec].setDisabled(state);
        }
    };
    return out;
}

export {GenerateInput, GenerateInputs};